const parseList = (item = {}, visibleData, args) => {
  const { scmv2 = '', pageName } = args;

  // 过滤header和footer
  if (typeof item.index !== 'number') {
    return null;
  }

  //   console.log('----item--', item);

  const couponId = item.item?.couponId ?? '';
  const index = item.item?._index || 0;
  return [
    {
      type: 'rec_list',
      item: item.item,
      isViewable: item.isViewable,
      key: item.key,
      index: index,
      page: pageName,
      b: pageName,
      c: 'voucher_list',
      d: index + 1,
      iid: `coupon_id=${couponId}`,
      scmv2: scmv2,
    },
  ];
};

const config = {
  // 消费券
  'Voucher.listVisible': {
    operation: ['VISIBLE'],
    title: '消费券item曝光',
    c: {
      type: 'constant',
      value: 'voucher_list',
    },
    getParse: {
      type: 'variable',
      func: parseList,
    },
  },
  'Voucher.itemTouch': {
    operation: ['TOUCH'],
    title: '消费券item点击',
    c: {
      type: 'constant',
      value: 'voucher_list',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        const { index } = traceData;
        return index;
      },
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const { couponId } = traceData || {};
        return `coupon_id=${couponId}`;
      },
    },
  },
};
export default config;
